import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/css/global.css'

createApp(App).use(router).use(store).use(VueAxios, axios).mount('#app')
